import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { CssBaseline, NoSsr, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { BASE_PATH } from './core/config';
import { router } from './core/config/routes';
import { mainTheme } from './core/theme_v5/mainTheme';
import UpdatesListenerWrapper from './main/elevators/websockets/updates-listener-wrapper/UpdatesListenerWrapper';
import store from './store';
import CookiePopup from './ui/components/cookie-popup/CookiePopup';
import FlashMessage from './ui/components/flash-messages/flash-message/FlashMessage';
import GeneralInfoOverlay from './ui/components/general-info-overlay/GeneralInfoOverlay';
import TermsOverlay from './ui/components/terms-overlay/TermsOverlay';
import UpdateOverlay from './ui/components/update-overlay/UpdateOverlay';

TimeAgo.addDefaultLocale(en);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: 2,
      staleTime: 10 * 60,
    },
  },
});

if (!window.location.pathname.includes(BASE_PATH)) {
  window.location.replace('/app/home');
}

function App() {
  return (
    <NoSsr>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <UpdatesListenerWrapper />
          <ThemeProvider theme={mainTheme}>
            <CssBaseline />
            <RouterProvider router={router} />
            <UpdateOverlay />
            <TermsOverlay />
            <CookiePopup />
            <FlashMessage />
            <GeneralInfoOverlay />
            <ReactQueryDevtools initialIsOpen={false} />
          </ThemeProvider>
        </QueryClientProvider>
      </Provider>
    </NoSsr>
  );
}

export default App;
